import { createContextScope, type Scope } from '@radix-ui/react-context';
import { type RefObject } from 'react';

export const PLAYER_PREVIEW_NAME = 'PlayerPreview';
export const PLAYER_PREVIEW_CONTENT_NAME = 'PlayerPreviewContent';
export const PLAYER_PREVIEW_SPRITESHEET_NAME = 'PlayerPreviewSpritesheet';
export const PLAYER_PREVIEW_TRIGGER_NAME = 'PlayerPreviewTrigger';
export const PLAYER_PREVIEW_TIMESTAMP_NAME = 'PlayerPreviewTimestamp';
export const PLAYER_PREVIEW_HLS_NAME = 'PlayerPreviewHls';

export type PlayerPreviewScopeProps<P> = P & {
  __scopePlayerPreview?: Scope;
};

export const [createPlayerPreviewContext, createPlayerPreviewScope] = createContextScope(PLAYER_PREVIEW_NAME);

export type PlayerPreviewContextValue = {
  contentId: string;
  contentRef: RefObject<HTMLDivElement>;
  open: boolean;
  position: number;
  onPreviewStart: (position: number) => void;
  onPreviewEnd: () => void;
  triggerRef: RefObject<HTMLDivElement>;
};

export const [PlayerPreviewProvider, usePlayerPreviewContext] =
  createPlayerPreviewContext<PlayerPreviewContextValue>(PLAYER_PREVIEW_NAME);
